import { SupabaseAllMomentStatsService } from "../../../../modules/stats/server/analytics-service";
import { useSupabaseCallback } from "../../../../server/supabase/hooks";

import type { MomentFormMoment } from "../../../../modules/moment/types/moment-form-moment";
import type { MomentStat } from "../../../../modules/stats/server/analytics-service";

interface UseAllMomentStatsState {
  load: () => Promise<MomentStat[] | undefined>;
}

export const useAllMomentStats = ({ id }: Pick<MomentFormMoment, "id">): UseAllMomentStatsState => {
  const load = useSupabaseCallback(
    async ({ supabase, account_id }) => {
      const service = new SupabaseAllMomentStatsService(supabase);

      const result = await service.getAll(account_id, {
        order: [{ column: "timestamp" }],
        filter: [{ key: "moment_id", operator: "eq", value: id }],
      });

      if (result.error) throw result.error;

      return result.data ?? [];
    },
    [id],
  );

  return { load };
};
